import { useState, useEffect } from "react";
import useDebounce from "~/hooks/useDebounce";
import crmApi, { ICustomer } from "~/apis/crm";
import {
  UseCustomersSearchReturn,
  JobStep,
} from "../types/add-job.types";

export const useCustomersSearch = (
  isOpen: boolean,
  jobStep: JobStep,
  initialSelected: ICustomer[] = []
): UseCustomersSearchReturn => {
  const [customers, setCustomers] = useState<ICustomer[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [selectedContact, setSelectedContact] = useState<ICustomer[]>(
    initialSelected
  );
  const debouncedSearchText = useDebounce(searchText, 500);

  // Fetch Customers from API with search
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await crmApi.getCustomersList({
          textSearch: debouncedSearchText || undefined,
        });
        if (response.data?.data?.responses) {
          setCustomers(response.data.data.responses);
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    if (isOpen && jobStep === "Existing") {
      fetchCustomers();
    }
  }, [isOpen, debouncedSearchText, jobStep]);

  return {
    customers,
    searchText,
    setSearchText,
    selectedContact,
    setSelectedContact,
  };
};

